import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/AdvertisementManagement';
import { GetDetailCompanyOrganizerRequested, ClearGetDetailCompanyOrganizer } from '../../actions/CompanyManagementOrganizer';
import AdvertisementRegister from '../../pages/AdvertismentRegister/AdvertisementRegister';
import withAuth from '../../common/WithAuth';

const mapStateToProps = (state) => {
    const isLoading = state.advertisementManagement.getAds.isFetching;

    return ({
        adsData: state.advertisementManagement.getAds.data && state.advertisementManagement.getAds.data.results,
        updateSuccess: state.advertisementManagement.updateAds.success,
        deleteSuccess: state.advertisementManagement.deleteAds.success,
        createSuccess: state.advertisementManagement.createAds.success,
        advertisementManagent: state.advertisementManagement.getAds.data,
        maxAdsRegister: state.companyManagementOrganizer.detailCompanyOrganizer.data
        && state.companyManagementOrganizer.detailCompanyOrganizer.data.company
        && state.companyManagementOrganizer.detailCompanyOrganizer.data.company.register_ads_max,
        companyId: state.auth.credential.data.company_id,
        isLoading,
        infoEvent: state.registrationOrganizer.registrationOrganizer.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchGetAds: (params) => dispatch(Actions.GetAdvertisementRequested(params)),
    fetchGetDetailCompany: (params) => dispatch(GetDetailCompanyOrganizerRequested(params)),
    fetchClearDetailCompany: (params) => dispatch(ClearGetDetailCompanyOrganizer(params)),
    fetchCreateAds: (params) => dispatch(Actions.CreateAdvertisementRequested(params)),
    fetchUpdateAds: (params) => dispatch(Actions.UpdateAdvertisementRequested(params)),
    fetchDeleteAds: (params) => dispatch(Actions.DeleteAdvertisementRequested(params)),
    fetchClearGetAds: () => dispatch(Actions.ClearGetAdvertisement()),
    fetchClearGetDetailCompany: () => dispatch(ClearGetDetailCompanyOrganizer()),
    fetchClearCreateAds: () => dispatch(Actions.ClearCreateAdvertisement()),
    fetchClearUpdateAds: () => dispatch(Actions.ClearUpdateAdvertisement()),
    fetchClearDeleteAds: () => dispatch(Actions.ClearDeleteAdvertisement()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(AdvertisementRegister);
